import { AiToolOffice } from '../ai-details/ai-tool-office';
import { Component, OnInit, Input, Inject, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { LoaderService } from '../../shared/loader/loader.service';

@Component({
  selector: 'app-addAIQualificationTemplate',
  templateUrl: './addAIQualificationTemplate.component.html',
  styleUrls: ['./addAIQualificationTemplate.component.scss']
})

export class AddAIQualificationTemplateComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  spinner: boolean = false;
  referralID: number = 0;
  coreID: number = 0;
  documentID: number = 0;
  position: number = 0;
  text: string = "Save";
  isFollowUpFlag: boolean = false;
  gridsize: number = 5;
  isMandatoryRule: boolean = true;
  isMandatoryPass: boolean = true;
  selectedType: string = 'PASS';
  questionID: number = 0;
  questionTitle: string = "";
  rules: any = [] = [];

  constructor(private dialog: MatDialog, private dialog1: MatDialog, private datePipe: DatePipe, public dialogRef: MatDialogRef<AddAIQualificationTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService, private loaderService: LoaderService,) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe: any) => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = AiToolOffice.resolve(oe.officeID);   // [per-office] the office the open AI tool works for
      });
    }

  }

  ngOnInit(): void {
    this.questionID = this.data.questionID;
    this.rules = this.data.allrecords;
    if (this.questionID == 0) {
      this.text = "Save";
    }
    if (this.questionID > 0) {
      this.text = "Update";
    }
    if (this.data.questionID > 0) {
      this.questionTitle = this.data.records.questionTitle;
      this.gridsize = this.data.records.weight;
      this.isMandatoryPass = this.data.records.isMandatoryPass;
      this.isMandatoryRule = this.data.records.mandatoryRule;
      this.position = this.data.records.position;
      this.isFollowUpFlag = this.data.records.isFollowUpFlag;
      if (this.isMandatoryRule == true) {
        this.selectedType == "PASS";
      }
      if (this.isMandatoryRule == false) {
        this.selectedType == "FAIL";
      }
    }


  }


  numberOnly(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow: Backspace, Tab, Delete, Left, Right arrows
    if ([8, 9, 46, 37, 39].includes(charCode)) {
      return true;
    }

    // Allow numbers (0-9)
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }

    // Allow decimal point (.)
    if (charCode === 46) {
      // Prevent more than one decimal point
      const inputValue = (event.target as HTMLInputElement).value;
      if (inputValue.includes('.')) {
        return false;
      }
      return true;
    }

    return false;
  }

  closeDialog() {
    this.dialogRef.close();
  }



  updateSetting(event: any) {
    this.gridsize = Number(event.value);
  }

  onMandatoryChange(event: MatCheckboxChange) {
    this.isMandatoryRule = event.checked;
    if (this.isMandatoryRule == true) {
      this.selectedType = "PASS";
    }
  }



  onTypeSelect(type: any) {
    this.selectedType = type;
    if (this.selectedType == "PASS") {
      this.isMandatoryPass = true;
    }
    if (this.selectedType == "FAIL") {
      this.isMandatoryPass = false;
    }
  }



  saveAIQualification() {
    this.questionID = this.data.questionID;
    if (this.questionID == 0) {
      this.addThresholdRules();
    }
    if (this.questionID > 0) {
      this.UpdateThresholdRulesBulk();
      this.updateThresholdRules();
    }

  }


  addThresholdRules() {
    this.referralID = this.data.referralID;
    this.coreID = this.data.coreId;
    this.documentID = this.data.documentId;
    if (this.isMandatoryRule == false) {
      this.isMandatoryPass = false;
    }

    var ReqModel = {
      referralID: Number(this.referralID),
      questionID: Number(this.questionID),
      questionTitle: this.questionTitle,
      weight: Number(this.gridsize),
      isMandatoryPass: this.isMandatoryPass,
      mandatoryRule: this.isMandatoryRule,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      isFollowUpFlag: this.isFollowUpFlag,
      officeID: this.myOfficeID,
      position: 0,
      coreID: this.coreID,
      documentID: this.documentID,
      referralTemplateID: 0,
    };
    this.spinner = true;
    this.loaderService.show();
    this.coreService.addUpdateThresholdRules(ReqModel).subscribe(async (response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Record save successfully.', '', {
            timeOut: 3000,
          });
          this.dialogRef.close("RecordAdded");
        } else {
          this.loaderService.hide();
          this.toastr.error('Record save failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.toastr.error('Record save failed.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
      }

    });
  }

  updateThresholdRules() {
    this.referralID = this.data.referralID;
    this.coreID = this.data.coreId;
    this.documentID = this.data.documentId;

    if (this.isMandatoryRule == false) {
      this.isMandatoryPass = false;
    }

    var ReqModel = {
      // referralID:Number(this.referralID),
      questionID: Number(this.questionID),
      questionTitle: this.questionTitle,
      weight: Number(this.gridsize),
      isMandatoryPass: this.isMandatoryPass,
      mandatoryRule: this.isMandatoryRule,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      isFollowUpFlag: this.isFollowUpFlag,
      //position:this.position,
      //  coreID:this.coreID,
      // documentID:this.documentID,
      // referralTemplateID:0,
    };
    this.spinner = true;
    this.loaderService.show();
    this.coreService.updateThresholdRule(ReqModel).subscribe(async (response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Record update successfully.', '', {
            timeOut: 3000,
          });
          this.dialogRef.close("RecordAdded");
        } else {
          this.loaderService.hide();
          this.toastr.error('Record update failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.toastr.error('Record update failed.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
      }

    });
  }

  UpdateThresholdRulesBulk() {
    var tempQuery = [];
    if (this.rules.length > 0) {
      for (let i = 0; i < this.rules.length; i++) {
        if (this.rules[i].mandatoryRule == false) {
          this.rules[i].isMandatoryPass = false;
        }
        var obj = {
          questionID: this.rules[i].quetionID,
          questionTitle: this.rules[i].questionTitle,
          weight: this.rules[i].weight,
          position: this.rules[i].position,
          isMandatoryPass: this.rules[i].isMandatoryPass,
          mandatoryRule: this.rules[i].mandatoryRule,
          isFollowUpFlag: this.rules[i].isFollowUpFlag
        };
        tempQuery.push(obj);
      }
    }
    var ReqModel = {
      referrralID: this.referralID,
      updateReferralQueueQuetion: tempQuery,
      userID: this.currentUser.UID,
      thresholdValue: this.gridsize,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.coreService.updateThresholdRules(ReqModel).subscribe((response: any) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  onFollowUpFlagChange(event: MatCheckboxChange) {
    this.isFollowUpFlag = event.checked;
  }

}
